<template>
  <div class="pick-lottery-quick-pick-button">
    <LcButton
      v-bind="{ disabled, icon, size, variant }"
      class="button"
      no-padding
      @click="openQuickPickModal"
    >
      {{ $t('lottery.quickpick.button') }}
    </LcButton>
  </div>
</template>

<script lang="ts" setup>
import type { LcButtonProps } from '@lottocom/frontend-components'

import { PickLotteryQuickPickModal } from '#components'

import type {
  PickLotteryQuickPickModalConfirmPayload,
  PickLotteryQuickPickModalEmits,
  PickLotteryQuickPickModalProps,
} from './PickLotteryQuickPickModal.vue'

type PickLotteryQuickPickProps = Pick<LcButtonProps, 'disabled' | 'icon' | 'size' | 'variant'> &
  PickLotteryQuickPickModalProps

const emit = defineEmits<PickLotteryQuickPickModalEmits>()
const { disabled, icon, size, variant, ...modalProps } = defineProps<PickLotteryQuickPickProps>()

const { openModal } = useModal()

const openQuickPickModal = () =>
  openModal({
    component: PickLotteryQuickPickModal,
    props: {
      ...modalProps,
      onConfirm: (payload: PickLotteryQuickPickModalConfirmPayload) => emit('confirm', payload),
    },
  })
</script>

<style lang="scss" scoped>
.pick-lottery-quick-pick-button {
  &,
  .button {
    width: 100%;
  }
}
</style>
